import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { Form, message, Spin } from "antd";
import { useTasks } from "../hooks/useTasks";
import TaskForm from "./TaskForm";
import { formatToSQLDate } from "../../../../utils/dateUtils";
import CustomModal from "../../../../components/Common/CustomModal";
import { ClassTask } from "../../../../types/classTaskTypes";

interface TaskModalProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: FormData) => Promise<boolean>;
  teacherId: string;
  initialValues?: Partial<ClassTask>;
}

const TaskModal: React.FC<TaskModalProps> = ({
  visible,
  onClose,
  onSubmit,
  teacherId,
  initialValues,
}) => {
  const [form] = Form.useForm();
  const { classData, subjects, fetchClasses, loading } = useTasks({ teacherId });
  const isEditing = !!initialValues;
  const [loadingSave, setLoadingSave] = React.useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (visible) {
      fetchClasses(teacherId);
    }
  }, [visible, teacherId]);

  const handleSave = async () => {
    try {
      setLoadingSave(true);
      const values = await form.validateFields();
      const formData = new FormData();

      Object.entries(values).forEach(([key, value]) => {
        if (key !== "attachments" && key !== "removedFiles") {
          if (key === "date" || key === "dueDate") {
            const formattedDate = formatToSQLDate(value as string);
            if (formattedDate !== null) {
              formData.append(key, formattedDate);
            }
          } else if (value !== undefined && value !== null) {
            formData.append(key, String(value));
          }
        }
      });

      if (values.attachments && Array.isArray(values.attachments)) {
        values.attachments.forEach((file: File, index: number) => {
          if (file instanceof File) {
            formData.append("attachments", file);
          }
        });
      }

      if (isEditing && values.removedFiles && values.removedFiles.length > 0) {
        values.removedFiles.forEach((fileUrl: string) => {
          formData.append("removedFiles[]", fileUrl);
        })
      }

      const res = await onSubmit(formData);

      if (res) {
        form.resetFields();
        onClose();
      }
    } catch (err: any) {
      console.error("Form validation failed:", err);
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <CustomModal
      title={isEditing ? t("edit_task") : t("create_task")}
      isOpen={visible}
      onClose={() => {
        form.resetFields();
        onClose();
      }}
      loading={loadingSave}
      onSave={handleSave}
      saveText={isEditing ? t("update") : t("create")}
    >
      {/* {loading ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" tip={t("loading")} />
        </div>
      ) : ( */}
        <TaskForm
          form={form}
          initialValues={initialValues}
          classData={classData}
          subjects={subjects}
          isEditing={isEditing}
        />
      {/* )} */}
    </CustomModal>
  );
};

export default TaskModal;